// store.ts (React Redux setup)
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import authReducer from '../features/auth/authSlice';
import userMetaReducer from '../features/user/userMetaSlice';
import userUpdateSlice from '../features/user/userUpdateSlice';
import userMakeOrderSlice from '../features/user/userMakeOrderSlice';
import userEditSlice from '../features/user/userEditSlice';
import activateAccount from '../features/auth/activateAccount';
import cardsReducer from "../features/cards/cardsSlice";
import analyticsReducer from "../features/analytics/analyticsSlice";
import rateReducer from "../features/rate/rateSlice";
import csrfReducer from '../features/csrf/csrfSlice';
import userMetaDataSlice from '../features/user/userMetaDataSlice';
import frontGlobalsSlice from '../features/front-globals/frontGlobalsSlice';
import servicesSlice from '../features/services/servicesSlice';
import ordersSlice from '../features/orders/ordersSlice';
import ameriaPaymentSlice from '../features/payments/ameriaPaymentSlice';

export const store = configureStore({
  reducer: {
    csrf: csrfReducer,
    user: userReducer,
    auth: authReducer,
    userMeta: userMetaReducer,
    userUpdate: userUpdateSlice,
    userMakeOrder: userMakeOrderSlice,
    activateAccount: activateAccount,
    userEdit: userEditSlice,
    cards: cardsReducer,
    analytics: analyticsReducer,
    rate: rateReducer,
    userMetaData: userMetaDataSlice,
    frontGlobals: frontGlobalsSlice,
    services: servicesSlice,
    orders: ordersSlice,
    payment: ameriaPaymentSlice,
  },
});

// Inferred types for use throughout the app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;